module.exports = __webpack_public_path__ + "img/02_noff_close_L3.7b7f19d1.svg";